import Vue from 'vue'
import './case'
import clamp from './clamp.js'

Vue.directive('clamp', clamp)
